import { Stack, Typography } from "@mui/material";
import { FC, Fragment } from "react";
import EmptyInfrastructureArchitecture from "@/assets/empty-states/empty-infrastructure-architecture.svg";

export const InfrastructureArchitectureDiagramUninitializedCase: FC = () => {
  return (
    <Fragment>
      <img
        src={EmptyInfrastructureArchitecture}
        alt="Empty Infrastructure Architecture"
      />

      <Stack spacing={2} alignItems="center">
        <Typography variant="h6" fontWeight="normal">
          Start by selecting a cloud account, region and service.
        </Typography>
        <Typography
          variant="body2"
          fontWeight="normal"
          color="text.secondary"
          width={650}
          textAlign="center"
        >
          Once selected, Cloudchipr will analyze your infrastructure and provide
          tailored recommendations to help you improve structure, performance,
          and reliability.
        </Typography>
      </Stack>
    </Fragment>
  );
};
